// Vite environment variable compatibility layer
// Provides backward compatibility for legacy environment variable usage

// Helper to get environment variables with fallback support
function getEnvVar(key: string): string | undefined {
  const env = import.meta.env;
  
  // Try VITE_ prefix first (current standard)
  const viteKey = key.replace('REACT_APP_', 'VITE_') as keyof ImportMetaEnv;
  if (env[viteKey] !== undefined) {
    return env[viteKey] as string;
  }
  
  // Fall back to legacy prefix for compatibility
  const reactKey = key as keyof ImportMetaEnv;
  if (env[reactKey] !== undefined) {
    return env[reactKey] as string;
  }
  
  return undefined;
}

// Create a compatibility layer for libraries expecting process.env
export const processEnv = new Proxy({} as Record<string, string | undefined>, {
  get(_target, prop: string) {
    if (prop.startsWith('REACT_APP_')) {
      return getEnvVar(prop);
    }
    return (import.meta.env as any)[prop];
  }
});

// For modern usage: export Vite's import.meta.env
export const env = import.meta.env;

